import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Filter/sort/add-to-calendar toolbar placeholder (TA-10273). Stands in for
 * the toolbar so a user can't open one of those controls before the task
 * list they act on has actually loaded. Mirrors `ComposedToolbar` in
 * `stories/atoms/Skeleton.stories.tsx`. Used by both the Project Tasks tab
 * and the My Tasks list.
 */
export const FilterToolbarSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'tasks-filter-toolbar-skeleton',
}) => (
  <Box
    testID={testID}
    flexDirection='row'
    alignItems='center'
    style={{ gap: theme.spacing.xs }}>
    {/* Filter/Sort buttons are 32px tall (PopupTaskButtonV3/PopupTaskSortButtonV3);
        Add to Calendar is 36px (explicit height prop on PublicCalendarLinkButtonV3). */}
    <Skeleton variant='rect' width={90} height={32} borderRadius='xs' />
    <Skeleton variant='rect' width={80} height={32} borderRadius='xs' />
    <Skeleton variant='rect' width={40} height={36} borderRadius='xs' />
  </Box>
);
